<template>
	<!-- header section -->
	<div data-bs-toggle="modal" data-bs-target="#notification-alert" ref="notifyMe"></div>
	<NotificationAlert @allowNotifications="allowNotifications" @cancelNotifications="cancelNotifications"/>
    <!-- header section -->
	<Header v-if="checkForHeaderShow() && !underMaintenance"></Header>


    <router-view  v-if="$siteSettings?.data || underMaintenance" />
	   
	<Footer v-if="!footerExcludedRoutes.includes($route.name) && !underMaintenance" ref="footer"  ></Footer>
    <!-- </footer> -->
	

	
	<!-- <div class="whatsapp-icon-btn" @click="getParentWhatsappNumber()" v-if="$siteSettings?.data && $siteSettings?.data?.business_type == 2 && $auth.status && routePath == 'Home'">
		<img class="w-img" src="@/assets/images/whatsapp_support.87f7de49.png" alt="whatsapp" loading="lazy">
	</div> -->
	
	<GotoTop v-if="routePath == 'Home'" />

    <div :class="{ show: successMsg }" class="successfully-wrapper" style="z-index: 9999999999999999;"
		ref="successmodal" id="successfullyModal">
		<SuccessModal :message="successMsg" />
	</div>

	<div :class="{ show: errorMsg }" style="z-index: 9999999999999999;" class="successfully-wrapper"
		id="wrongtoaster">
		<ErrorModal :message="errorMsg" />
	</div>
	<div class="yolo-loader-sec global-loader-color" v-if="globalLoader">
        <img src="@/assets/images/YOLO-LOADER.gif" alt="YOLO-LOADER"  loading="lazy"/>
    </div>
	<AndroidBanner />
</template>

<script>
import NotificationAlert from "./shared/components/modal/NotificationAlert.vue";
import { AUTH_TOKEN } from "./shared/constants/cookies-const";
import { mapGetters } from 'vuex';
import axios from 'axios';
import { setHeaders } from '@/shared/services/headers';
import socketService from "./socket/sport-socket-service";
import { defineAsyncComponent } from "vue";
import notificationAlert from "./shared/services/notificationAlert";
import { isApp as checkIsApp } from '@/shared/services/checkPlatform'
export default {
  name: 'App',
  extends: notificationAlert,
  components: {
    Header: defineAsyncComponent(() => import('@/shared/components/header/Header.vue')),
    Footer: defineAsyncComponent(() => import('@/shared/components/footer/Footer.vue')),
    SuccessModal: defineAsyncComponent(() => import('@/shared/components/modal/SuccessModal.vue')),
    ErrorModal: defineAsyncComponent(() => import('@/shared/components/modal/ErrorModal.vue')),
	
	GotoTop: defineAsyncComponent(() => import('@/shared/components/footer/GotoTop.vue')),
	WhatsAppModal: defineAsyncComponent(() => import('@/shared/components/modal/whatsAppModal.vue')),
	AndroidBanner: defineAsyncComponent(() => import('./shared/components/header/AndroidBanner.vue')),
	NotificationAlert,
  },
  data(){
        return{
			footerExcludedRoutes:[
				'login',
                'sign-up',
                'forget-password',
				'MatchDetails',
				'privacy-policy',
				'responsible-gaming',
				'terms-conditions',
				'about-us',
				'kyc-policy',
				'aml-policy',
				'self-exculusion-policy',
				'PlaceBet',
				'MyContests',
				'MyContestBetDetails',
				'NotFound',
				'AffDashboard',
                'AffUsersList',
                'AffProfitLoss',
                'AffStatement',
                'AffReports',
                'UserProfitLoss',
				'UserProfitLossDetails'
			],
            onLine: navigator.onLine,
            showBackOnline: false,
            refreshInit: false,
            scY: 0,
            scTimer: 0,
			LowBalanceModal:null,
			langData: null,
			findActiveLang:"",
			allLanguages:null,
			versionData:null,
			UpdatedVersion:null,
			interval : '',
			isApp : false
        }
    },
    computed: {
		...mapGetters(['successMsg', 'errorMsg', 'siteVersion', 'underMaintenance', 'eventDetailHideSections', 'globalLoader','logInData', 'mybetsTabActive']),
		routePath() {
			return this.$route.name
		},	
	},
	async created() {
			this.getAllSportsCount();
		},
    mounted() {
      //for use on js pages
      window.store = this.$store;
      window.cookies = this.$cookies;
      window.router = this.$router;
      window.emitLogoutMsg = this.$refs.click_logout_msg
      window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
      setHeaders();
	  this.getSiteVersion();
	  this.isApp = checkIsApp()
	  this.$errorToast(null);
	  this.$successToast(null);
      if (this.$auth.status) {
		if(!this.$auth.user?.notificationUnsubscribed && !this.$auth.user?.notificationSubscribed && this.$route.name != 'change-password'){
				this.requestNotificationPermission()
		}
      }

      //checking internet connection
      window.addEventListener('online', this.updateOnlineStatus);
      window.addEventListener('offline', this.updateOnlineStatus);
      if (localStorage.getItem('default_class')) {
        document.documentElement.className = localStorage.getItem('default_class')
      }
      window.addEventListener('scroll', this.onScroll);
	  if(!this.isApp) this.interval = setInterval(this.checkModalStatus, 60 * 1000);
	  this.socketAllEvents()
	  this.$store.dispatch('setMybetsTabActive', false);
    },
    methods: {
		async getSiteVersion() {
			this.$store.dispatch('setGlobalLoader', true);
			this.$apiCall('get', 'GET_SITE_VERSION', null, 'user', { domain: window.location.hostname }).then(async response => {
				if (response && response.status == 200) {
					if (response?.data?.status === 0) {
						this.$errorToast(response.data.debug[0]);
					} else {
						let resData = response?.data?.data;
						let currentVersion = resData.version;
						let userSystemVersion = this.siteVersion || 0;		
						if (!userSystemVersion || currentVersion != userSystemVersion || !this.$siteSettings.data) {
							this.$store.dispatch('setSiteVersion', currentVersion);
							this.getSiteSettingsServiceCall();
						} else {
							this.setSiteSttings(this.$siteSettings.data);
						}
						const fromDateTime = new Date(resData?.maintenance?.from_date).getTime();
						const toDateTime = new Date(resData?.maintenance?.to_date).getTime();
						const currentDateTime = Date.now(); 
						if (resData.maintenance != null && (fromDateTime && toDateTime && fromDateTime <= currentDateTime && currentDateTime <= toDateTime)) {
							this.$store.dispatch('setUnderMaintenance', resData.maintenance);
							this.$store.dispatch('setGlobalLoader', false);
							this.$router.push({name:'Maintenance'});
							return;
						} else {
							if(this.underMaintenance) {
								this.$router.push({name:'Home'});
							}
						this.$store.dispatch('setUnderMaintenance', null); 
						this.$store.dispatch('setGlobalLoader', false);
						}
						this.$store.dispatch('setGlobalLoader', false);
					}
				}
			}).catch(error => {
				if (error) {
					this.$store.dispatch('setGlobalLoader', false);
					this.$errorToast(error[0]);
				}
			});
		},
		androidPosterOpenPopUp(){
			// check if the modal already open
			const modalEl = document?.getElementById('andriodposter');
			const isOpen = modalEl?.classList?.contains('show');
			if(!isOpen  && this.$siteSettings?.data?.poster?.filter(s => s?.poster_type == 13)?.length && !this.underMaintenance && !this.$store.getters?.androidclose){
				this.$helper.openModal("#andriodposter");
			}
		},
		checkModalStatus() {
			const modalEl = document?.getElementById('andriodposter');
			const isOpen = modalEl?.classList?.contains('show');
			if(isOpen) return
			const lastClosed = localStorage.getItem("modalClosedAt");
			const now = Date.now();
			if ((!lastClosed || now - lastClosed >=  6 * 60 * 60 * 1000)) {
				if(this.$siteSettings?.data?.poster?.filter(s => s?.poster_type == 13)?.length && !this.underMaintenance && this.$store?.getters?.androidclose){
						this.$helper.openModal("#andriodposter");
				}
			}
		},
		getSiteSettingsServiceCall() {
			this.$store.dispatch('setGlobalLoader', true);
			this.$apiCall('get', 'GET_SITE_SETTINGS', null, 'user', { domain: window.location.hostname }).then(async response => {
				this.$store.dispatch('setGlobalLoader', false);
				if (response && response.status == 200) {
					if (response?.data?.status === 0) {
						this.$errorToast(response.data.debug[0]);
					} else {
						let resData = response?.data.data
						resData.siteSetting.announcement = JSON.parse(resData.siteSetting.announcement)
						resData.siteSetting.offer = resData.siteSetting.poster.find( pos => pos.poster_type == 12);
						resData.siteSetting.provider_currency = resData.siteSetting.provider_currency.reduce((a,b) =>{
							a[b.provider_id] = b.currency
							return a;
						}, {})	
						const { sub_domains, url } = resData.siteSetting;
						const parentSiteDomain = [];
						const otherSiteDomain = [];
						for (const item of sub_domains) {
							(item.url === url ? parentSiteDomain : otherSiteDomain).push(item);
						}
						resData.siteSetting.sub_domains = [...otherSiteDomain, ...parentSiteDomain];
						let bonus = resData?.bonus_data
						this.$store.dispatch('setSectionUrl', resData.section_url);
						try {
							await this.$store.dispatch('setSettings', resData.siteSetting);
						} catch (error) {
							console.log('error: ', error);
							
						}
						this.$store.dispatch('setBonusData', bonus);
						this.setSiteSttings(resData.siteSetting);
					}
				}
			}).catch(error => {
				this.$store.dispatch('setGlobalLoader', false);
				// this.$store.dispatch('setSiteVersion', null);
				if (error) {
					this.$errorToast(error[0]);
				}
			});
		},
		setSiteSttings(siteData) {
			if (siteData.languagesList) {
				this.$setCurrentLangData(siteData.languagesList, siteData.lang_code, siteData.aws_url)
				this.$store.dispatch('setLanguagesData', siteData.languagesList);
			}

			this.$store.dispatch('setSettings', siteData);
			this.setManifest(siteData);

				if(siteData.meta_pixel_code) {
					this.addFacebookPixel(siteData.meta_pixel_code);
				}
			// Create FAVICON
			const favElement = document.createElement('link');
			favElement.rel = 'icon';
			favElement.href = siteData.aws_url + siteData.storage_path.domain_image + siteData.fav_logo;
			document.head.insertAdjacentElement('beforeend', favElement);

			const title = document.getElementById("title");
			title.text = siteData?.site_title ? siteData?.site_title : siteData?.domain_name;
			if (this.$auth.status) {
				this.getWalletBalance();
				this.getFavourites();
				setTimeout(() => {
					this.handleUserIdAndOffer();
				}, 300);
			}
			if(siteData.meta_tags) {
					document.head.innerHTML += siteData.meta_tags;
				};
			if(siteData.g_tags) {
				this.setGoogleAnalyticsTag(siteData.g_tags);
			};
			if(siteData.site_map) {
				const sitemapLink = document.createElement("link");
				sitemapLink.rel = "sitemap";
				sitemapLink.type = "application/xml";
				sitemapLink.title = "Sitemap";
				sitemapLink.href = siteData.aws_url + siteData.storage_path.site_map + siteData.site_map;
				document.head.appendChild(sitemapLink);
			};
			if(!this.isApp) this.androidPosterOpenPopUp();
			try {
				if (siteData.front_css != null && siteData.front_css != '') {// Create a style element
					const styleElement = document.createElement('style');
					styleElement.type = 'text/css';
					styleElement.appendChild(document.createTextNode(siteData.front_css));
					document.head.insertAdjacentElement('beforeend', styleElement);
				}
			}
			catch (error) {
				console.log("ERROR 1: ", error);
			}
		},
		handleUserIdAndOffer(){
			if(this.logInData?.logInWithMobile){
				if(!this.logInData?.userIds?.includes(this.$auth?.user?.userid ) && !this.$auth.user?.isDemoLogin && this.$route.name != 'change-password'){
					this.showUserId()
				}
				else {
					this.handleOffer();
				}
			}
			else{
				if(!this.logInData?.userIds?.includes(this.$auth?.user?.userid )){
					let newUserIdsList = this.logInData?.userIds || [];
					newUserIdsList.push(this.$auth?.user?.userid)
					let data = {
						"logInWithMobile": this.logInData?.logInWithMobile,
						"userIds": newUserIdsList
					}
					this.$store.dispatch('setLogInData', data);
				}
				this.handleOffer();
			}
		},
		handleOffer(){
			let is_offer = this.$store.getters.isOffer;
			if (this.$auth.status && this.$siteSettings.data.offer != null && is_offer && !this.underMaintenance && this.$siteSettings?.data?.business_type == 2) {
				setTimeout(()=>{
                    this.$helper.openModal("#offer_pop_up");
				},400)
			}
		},
		showUserId() {
			setTimeout(() => {
				this.$helper.openModal('#userid_Modal');
			}, 200);
		},
		setGoogleAnalyticsTag(gTag) {
			let script1 = document.createElement('script');
			script1.async = true;
			script1.src = `https://www.googletagmanager.com/gtag/js?id=${gTag}`;

			let script2 = document.createElement('script');
			script2.innerHTML = `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '${gTag}');
			`;

			document.head.appendChild(script1);
			document.head.appendChild(script2);
		},
		setManifest(resData) {
			let manifestName = resData.domain_name.charAt(0).toUpperCase() + resData.domain_name.slice(1).toLowerCase();
			var dynamicManifest = {
				name: manifestName,
				short_name: manifestName,
				start_url: window.location.origin,
				display: 'standalone',
				icons: [{
					src: resData.app_logo ? resData.aws_url + resData.storage_path.domain_image + resData.app_logo : resData.aws_url + resData.storage_path.domain_image + resData.fav_logo,
					sizes: "256x256 512x512 192x192 144x144",
					type: "image/png",
					purpose: 'any'
				}]
			}

			// Manifest Blob
			const stringManifest = JSON.stringify(dynamicManifest);
			const blob = new Blob([stringManifest], { type: 'application/json' });
			const manifestURL = URL.createObjectURL(blob);

			// Manifest Creation
			const favElement = document.createElement('link');
			favElement.rel = 'manifest';
			favElement.href = manifestURL;
			document.head.insertAdjacentElement('beforeend', favElement);

			// IOS APK Logo
			let logo = resData.aws_url + resData.storage_path.domain_image + resData.logo;
			document.querySelector('#appleIcon').setAttribute('href', logo);
			document.querySelector('#appleLaunchIcon').setAttribute('href', logo);

			// IOS App title
			const metaTag = document.createElement('meta');
			metaTag.setAttribute('name', 'apple-mobile-web-app-title');
			metaTag.setAttribute('content', manifestName);
			document.head.insertAdjacentElement('beforeend', metaTag);

		},
		getFavourites() {
			let data = {
				"game_type": 1
			}
			this.$apiCall('post', 'GET_FAVOURITE_LIST', data).then(response => {
				if (response) {
					if (response.status == 200) {
						if (response?.data?.status != 0) {
							var allData = response.data.events;
							var ids = [];
							for (var i = 0; i < allData.length; i++) {
								ids.push(allData[i])
							}
							this.$store.dispatch('setFavouriteGames', ids)
						}
					}
				}
			}).catch(error => {
				if (error) {
					this.$errorToast(error[0]);
				}
			});
		},
		getWalletBalance() {
			this.$apiCall('post', 'WALLET_BALANCE').then(response => {
				if (response && response.status == 200 && response.data) {
					let user = this.$store.getters.stateUser;
					user.balance = response.data.bl;
					user.exposure = response.data.ex;
					user.bets_count = response.data.bc;
					user.earnBonus = response.data.eb;
					this.$store.dispatch('setUser', user);
					setTimeout(function () {
						this.getWalletBalance();
					}.bind(this), 2000);
				} else {
					this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
					this.$store.dispatch('resetAllState');
				}
			}).catch(error => {
				if (error) {
					this.$errorToast(error[0]);
				}
			});
		},
		getAllSportsCount(){
			this.loading = true;
            this.$apiCall('get', 'INPLAY_MATCHES_COUNT', null, 'sports').then(response => {
                this.loading = false;
                if (response && response.status == 200) {
					let resData =response?.data.data
					this.$store.dispatch('SetSportsCount',resData)
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    console.log("Error : ", error);
                }
            });
		},
		checkForHeaderShow() {
			const headerHideRoutes = ['NotFound']
			if (this.eventDetailHideSections && this.eventDetailHideSections.includes('show_full_screen') && this.routePath == 'sports-event-detail' || (headerHideRoutes.includes(this.routePath))) {
				return false;
			} else {
				return true;
			}
		},
		updateOnlineStatus(e) {
			const {
				type
			} = e;
			this.onLine = type === 'online';
		},
		goToTop() {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		},
		onScroll() {
			if (this.scTimer) return;
			this.scTimer = setTimeout(() => {
				this.scY = window.scrollY;
				clearTimeout(this.scTimer);
				this.scTimer = 0;
			}, 100);
		},
		
		socketAllEvents(){
			if(this.$store.getters.stateUser){
				socketService.emit("sub",'depositRequest-'+this.$store.getters.stateUser.userid);					
				socketService.emit("sub",'logout-'+this.$store.getters.stateUser.userid);					
				socketService.emit("sub",'banned-'+this.$store.getters.stateUser.userid);

				socketService.on("DepositRequest", (data) => {
					if (data.type =="myId") {
						if (data.notify_type == 1) {
							this.$store.dispatch('setNotification');
							this.$successToast('New Notification...')
						}
					}
				});
				socketService.on("logout", (data) => {
					if (data.type == "logout") {
						// logout user from users
						// if (data.notify_type == 1) {
						// 	this.$store.dispatch('setNotification');
						// 	this.$successToast('New Notification...')
						// }
					}
				});	
				socketService.on("banned", (data) => {
					if (data.type == "match_ban") {
						// match ban condition
					}else if(data.type == 'league_ban'){
						// league ban condition
					}
				});
					
			}			
		},
		addFacebookPixel(pixelId) {
			const script = document.createElement('script');
			script.innerHTML = `
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '${pixelId}');
				fbq('track', 'PageView');
			`;
			document.head.appendChild(script);

			// Add the noscript image
			const noscript = document.createElement('noscript');
			noscript.innerHTML = `
				<img height="1" width="1" style="display:none"
					src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>
			`;
			document.head.appendChild(noscript);
    	},
	},
	updated(){
        if (this.$auth?.user?.actw == 'WB' && !this.$auth.user?.isDemoLogin ) {
			document.body.classList.add('append-playwith-bonus');
			} else {
			document.body.classList.remove('append-playwith-bonus');
		}
	},
	watch: {
		onLine(v) {
			if (v) {
				this.showBackOnline = true;
				setTimeout(() => {
					this.showBackOnline = false;
				}, 1000);
			}
		}
	},
	beforeUnmount() {
		if(!this.isApp)	clearInterval(this.interval);
	},
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
 
 .pr-2{
	padding-right: 5px !important;
 }
</style>
